import { MouseEvent } from "react";
import { ListChecksIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const ReviewAllButton = ({
  count,
  onClick,
  className,
}: {
  count?: number;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}) => {
  const render = () => (
    <Button
      type="button"
      variant="outlineSecondary"
      size="sm"
      className={cn("h-9 gap-1.5 rounded-md", className)}
      onClick={onClick}
    >
      <ListChecksIcon className="h-3.5 w-3.5" />
      {count !== undefined ? `Review ${count.toLocaleString()}` : "Review all"}
    </Button>
  );

  return render();
};
